import React from 'react';
import { Icon } from './Icon.js';
export const IconArrowBoldRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M16.586,8.004L10.005,3.011c-.38-.288-.883-.335-1.311-.124-.429,.213-.694,.642-.694,1.12v1.993H2.75c-.965,0-1.75,.785-1.75,1.75v2.5c0,.965,.785,1.75,1.75,1.75h5.25v1.993c0,.478,.266,.907,.694,1.12,.177,.088,.368,.131,.557,.131,.267,0,.531-.086,.754-.255l6.581-4.994c.314-.238,.494-.601,.494-.996s-.18-.757-.494-.996Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconArrowBoldRightFill18.js.map